import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { PERIOD } from '../constant'
import { getMaxDate } from './thunk'

const initialState = {
  maxDate: {},

  period: PERIOD.YEAR.value,
}

const slice = createSlice({
  name: 'portfolio/common/period',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changePeriod: (state, action) => {
      state.period = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaxDate.fulfilled, (state, { payload }) => {
      state.maxDate = payload || {}
    })
  },
})

export const selectMaxDate = (state) => state[slice.name].maxDate

export const selectPeriod = (state) => state[slice.name].period

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const { resetStore, changePeriod } = slice.actions

register(slice.name, slice.reducer)
